import './StickyHeaderWrapper.css'
interface IProps {
    children: React.ReactNode
}
const StickyHeaderWrapper = ({ children }: IProps) => {
    return (
        <div id='StickyHeaderWrapper' className='sticky-header hidden-print'>
            {children}
        </div>
    )
}
export default StickyHeaderWrapper